<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Editar Empresa</h5>
                <hr>                
                <Panel header="Informações gerais" class="p-mt-3 p-mb-3">                    
                    <div class="p-fluid p-formgrid p-grid">                      
                        <div class="p-field p-col-12 p-md-2">
                            <label for="codigoCliente">Código do Cliente</label>
                            <InputText id="codigoCliente" v-model="empresa.id" readonly/>
                        </div>                                                           
                        <div class="p-field p-col-12 p-md-5">
                            <label for="razaoSocial">Razão social</label>
                            <InputText id="razaoSocial" type="text" v-model="cnpj.razaoSocial" readonly/>
                        </div>
                        <div class="p-field p-col-12 p-md-5">
                            <label for="nomeFantasia">Nome Fantasia</label>
                            <InputText id="nomeFantasia" type="text" v-model="empresa.nomeFantasia" readonly/>
                        </div>
                        <div class="p-field p-col-12 p-md-2">                           
                            <label for="cnpj">{{ cnpj.tipoNumeroDocumento == 'cnpj' ? 'CNPJ' : 'CPF' }}</label>
                            <InputText v-model="cnpj.numero" @keyup="formatarDocumento($event)"
                            required="true" autocomplete="off" maxlength="18" v-if="cnpj.tipoNumeroDocumento == 'cnpj'" readonly/>
                            <InputText v-model="cnpj.numero" @keyup="formatarDocumento($event)"
                            required="true" autocomplete="off" maxlength="14" v-else readonly/> 
                        </div>        
                        <div class="p-field p-col-12 p-md-2">
                            <label>Celular</label>
                            <InputMask mask="(99) 99999-9999" v-model="cnpj.celular" readonly/>
                        </div>                
                        <div class="p-field p-col-12 p-md-2">
                            <label for="tel1">Telefone 1</label>
                            <InputMask id="tel1" mask="(99) 9999-9999" v-model="cnpj.telefone1" readonly/>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                            <label for="tel2">Telefone 2</label>
                            <InputMask id="tel2" mask="(99) 9999-9999" v-model="cnpj.telefone2" readonly/>
                        </div> 
                        <div class="p-field p-col-12 p-md-2">
                            <label for="tipoSeguimento">Tipo de Seguimento</label>
                            <InputText id="tipoSeguimento" v-model="empresa.seguimento" autocomplete="off" readonly/>
                        </div> 
                        <div class="p-field p-col-12 p-md-2">
                            <label for="status">Status</label>
                            <InputText value="Inativo" v-if="empresa.status == '0'" readonly/>
                            <InputText value="Ativo" v-else-if="empresa.status == '1'" readonly/>
                            <InputText value="Bloqueado" v-else readonly/>                            
                        </div>      
                        <div class="p-field p-col-12 p-md-4" v-if="empresa.status != '1'">
                            <label for="motivo">Motivo</label>
                            <InputText id="motivo" v-model.trim="empresa.motivoInativo" readonly/>
                        </div>                 
                    </div>
                    <Button type="button" icon="pi pi-pencil" label="Editar Status"  @click="editarStatusModal"/>	
                </Panel>
                <Panel header="Endereço" class="p-mt-3 p-mb-3">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-2 p-md-2">
                            <label>Tipo de local</label>                           
                            <InputText v-model.trim="cnpj.endereco.tipoLocal" readonly/>
                        </div>
                        <div class="p-field p-col-8 p-md-8">
                            <label>Descrição</label>
                            <InputText v-model.trim="cnpj.endereco.rua" readonly/>
                        </div>
                        <div class="p-field p-col-2 p-md-2">
                            <label>Número</label>
                            <InputText type="text" v-model.trim="cnpj.endereco.numero" readonly/>
                        </div>
                        <div class="p-field p-col-3 p-md-3">
                            <label for="cep">CEP</label>
                            <InputMask mask="99-999-999" id="cep" v-model="cnpj.endereco.cep" placeholder="__-___-___" readonly/>
                        </div>
                        <div class="p-field p-col-9 p-md-9">
                            <label>Bairro</label>
                            <InputText v-model.trim="cnpj.endereco.bairro" readonly/>
                        </div> 
                        <div class="p-field p-col-6 p-md-6">
                            <label>Complemento</label>
                            <InputText v-model.trim="cnpj.endereco.complemento" readonly/>
                        </div> 
                        <div class="p-field p-col-3 p-md-3">
                            <label>Estado</label>                            
                            <InputText v-model.trim="cnpj.estado.uf" readonly/>				
                        </div> 
                        <div class="p-field p-col-3 p-md-3">
                            <label>Cidade</label>                           
                            <InputText v-model.trim="cnpj.endereco.cidade.nome" readonly/>
                        </div> 
                    </div>
                </Panel>
                <Button label="Cancelar Edição Plano" class="p-button-secondary p-ml-2" icon="pi pi-times" @click="novoPlano=false" v-if="novoPlano"/>
                <Button label="Permissões Plano atual" class="p-ml-2 p-button-success" icon="pi pi-eye" @click="exibirPermissoesExtras=true" v-if="novoPlano"/>  
                <Panel header="Plano" class="p-mt-3 p-mb-3" v-if="!novoPlano">                      
                    <div class="p-mb-3">
                        <Button label="Novo Plano" icon="pi pi-plus" @click="panelNovoPlano"/>
                        <Button label="Permissoes Excluídas" icon="pi pi-eye" class="p-button-success p-ml-2" @click="exibirDialogPermissoesExcluidas=true"/>
                        <Button label="Benefícios" class="p-button-success p-ml-2" icon="pi pi-eye" @click="exibirDialogBeneficios=true"/>
                    </div>             
                    <div class="p-fluid p-formgrid p-grid"> 
                        <div class="p-field p-col-12 p-md-6">
                            <label for="nome">Nome</label>
                            <InputText id="nome" v-model="planoEmpresa.nome" readonly/> 
                        </div> 
                        <div class="p-field p-col-12 p-md-2">
                            <label>Qtd. Pessoas</label>
                            <InputText v-model="planoEmpresa.quantidadePessoas" class="p-text-right" readonly/>
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                            <label>Qtd. de Usuários</label>
                            <InputText type="text" v-model="planoEmpresa.quantidadeUsuarios" class="p-text-right" readonly/>                         
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                            <label>Qtd. de CNPJs</label>
                            <InputText type="text" v-model="planoEmpresa.quantidadeCNPJs" class="p-text-right" readonly/>                                     
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                            <label>Qtd. de Usuários App</label>
                            <InputText type="text" v-model="planoEmpresa.quantidadeUsuariosApp" class="p-text-right" readonly/>                                               
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                            <label>Qtd. de Usuários Web</label>
                            <InputText type="text" v-model="planoEmpresa.quantidadeUsuariosWeb" class="p-text-right" readonly/>                                               
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                            <label>Pagamento {{ planoEmpresa.tipoPagamento }}</label>
                            <InputText v-model="planoEmpresa.valor" class="p-text-right" readonly/>                               
                        </div>  
                        <div class="p-field p-col-12 p-md-2">
                            <label>Validade</label>
                            <InputText value="Produção" v-if="planoEmpresa.validade == 'Producao'" readonly/>
                            <InputText value="Teste" v-if="planoEmpresa.validade == 'Teste'" readonly/>                               
                        </div> 
                        <div class="p-field p-col-12 p-md-12">
                            <label>Complemento</label>
                            <Textarea v-model="planoEmpresa.complemento" rows="3" cols="12" readonly/>
                        </div>                                                                                               
                    </div>
                </Panel>
                <FormPlano ref="formPlano" v-if="novoPlano"/>  
                <Button label="Fechar" class="p-button-secondary" icon="pi pi-times" @click="cancelar"/>                
                <Button label="Salvar" class="p-ml-2" icon="pi pi-check" @click="trocarPlano" v-if="novoPlano"/>                                             
            </div>            
        </div>
        <Dialog :visible.sync="exibirDialogPermissoesExcluidas" header="Permissões Excluídas" :modal="true" :style="{width: '40vw'}">
            <Listbox :options="planoEmpresa.permissoesExcluidas" optionLabel="nome" :filter="true" listStyle="max-height:250px">
                <template #option="slotProps">
                    {{slotProps.option.codigo}} - {{slotProps.option.nome}} 
                </template>
            </Listbox>
            <template #footer>
                <Button label="OK" icon="pi pi-check" @click="exibirDialogPermissoesExcluidas=false"/>
            </template>
        </Dialog>
        <Dialog :visible.sync="exibirDialogBeneficios" header="Benefícios" :modal="true" :style="{width: '40vw'}">
            <Listbox :options="planoEmpresa.beneficios" optionLabel="nome" :filter="true" listStyle="max-height:250px">
                <template #option="slotProps">
                    {{slotProps.option.nome}} 
                    <i class="pi pi-check" v-if="slotProps.option.selecionado"></i>
                    <i class="pi pi-times" v-if="!slotProps.option.selecionado"></i>
                </template>
            </Listbox>
            <template #footer>
                <Button label="OK" icon="pi pi-check" @click="exibirDialogBeneficios=false"/>
            </template>
        </Dialog>
        <Dialog :visible.sync="exibirPermissoesExtras" header="Permissões Plano atual" :modal="true" :style="{width: '40vw'}">            
            <p>Selecione as permissões para incluir no novo plano.</p>            
            <Listbox v-model="permissaoExtraSelecionada" :options="permissoesUsuarioDonoConta" optionLabel="nome" :filter="true" listStyle="max-height:250px">
                <template #option="slotProps">
                    {{slotProps.option.codigo}} - {{slotProps.option.nome}} 
                    <i class="pi pi-check" v-if="slotProps.option.selecionada"></i>
                </template>
            </Listbox> 
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field-checkbox p-ml-2" v-if="permissaoExtraSelecionada">                        
                    <Checkbox v-model="permissaoExtraSelecionada.selecionada" :binary="true"/>     
                    <label>Selecionar {{ permissaoExtraSelecionada.nome }}</label>                   
                </div> 
            </div>           
            <template #footer>                
                <Button label="OK" icon="pi pi-check" @click="exibirPermissoesExtras=false"/>
            </template>
        </Dialog>
        <Dialog :visible.sync="exibirDialogAlterarStatus" header="Editar Status" :modal="true" :breakpoints="{'960px': '75vw'}" :style="{width: '40vw'}">
            <div class="confirmation-content">
                <div class="p-fluid p-formgrid p-grid">  
                    <div class="p-field p-col-2 p-md-12">
                        <section>       
                            <input type="radio" v-model="empresaEditarStatus.status" value="1">Ativo                              
                            <input type="radio" v-model="empresaEditarStatus.status" value="2">Bloqueado  
                            <input type="radio" v-model="empresaEditarStatus.status" value="0">Inativo
                        </section>
                    </div>
                    <div class="p-field p-col-12 p-md-12">
                        <label for="complemento">Complemento</label>
                        <span class="p-float-label">
                            <Textarea id="complemento" v-model="empresaEditarStatus.motivoInativo" rows="5" />                                    
                        </span>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
                <Button label="Salvar" icon="pi pi-check" @click="editarStatus"/>
            </template>
        </Dialog>
    </div>
</template>

<script>

import FormPlano from '@/components/pages/cadastro/cliente/FormPlano';
import Cnpj from '@/model/Cnpj';
import Plano from '@/model/Plano';
import PlanoService from '@/service/PlanoService';
import MenuService from '@/service/MenuService';
import EmpresaService from '@/service/EmpresaService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
    planoService: null,
    empresaService: null,
    menuService: null,
    props: ['id'],
    data() {
        return {
            novoPlano: false,
            enviandoForm: false,    
            exibirPermissoesExtras: false,
            exibirDialogPermissoesExcluidas: false,
            exibirDialogBeneficios: false,     
            exibirDialogAlterarStatus: false, 
            permissaoExtraSelecionada: null,
            permissoesUsuarioDonoConta: [],
            cnpj: new Cnpj(),
            idPlanoSelecionado: null,
			planoSelecionado: new Plano(),
            planoEmpresa: new Plano(),           
            empresa: {},  
            empresaEditarStatus: {},
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),  
        validarEdicao() {                   
            let requisicao = {
                idEmpresa: this.id,                   
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };               
            this.empresaService.buscar(requisicao)
                .then(resp => {                  
                    let data = resp.data;        
                    data.todasPermissoes.forEach(perm => perm['selecionada'] = false);
                    this.permissoesUsuarioDonoConta = data.todasPermissoes;
                    this.cnpj = data.cnpj;
                    this.empresa = data.empresa;
                    this.cnpj['estado'] = data.estado;
                    this.planoEmpresa = data.plano;       
                    this.planoSelecionado = data.plano;
                    this.formatarDocumento();
                    this.listarPlanos();                                        
                })			
        },           
        listarPlanos() {
            let requisicao = {                    
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };  
            this.planoService.listarAtivos(requisicao)
                .then(resp => {					
                    this.planos = resp.data;                        			
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },  
        trocarPlano() {   
            this.$refs.formPlano.validarCampos(this.enviandoForm);
            this.planoSelecionado = this.$refs.formPlano.getPlano();
            if(this.planoSelecionado.nome == '' || this.planoSelecionado.quantidadePessoas == null
                || this.planoSelecionado.quantidadePessoas <= 0
                || (this.planoSelecionado.tipoPagamento == 1 && 
                    (this.planoSelecionado.valorMensal == null || this.planoSelecionado.valorMensal <= 0))
                || (this.planoSelecionado.tipoPagamento == 2 && 
                    (this.planoSelecionado.valorAnual == null || this.planoSelecionado.valorAnual <= 0))) {
                return;
            }
            // Permissões selecionadas do plano atual.
            let selecionadas = [];            
            this.permissoesUsuarioDonoConta.forEach(perm => {
                if(perm.selecionada) {
                    selecionadas.push(perm);
                }
            });
            // Exclui das permissões excluídas do novo plano.
            selecionadas.forEach(permSelect => {
                for(let i = 0; i < this.planoSelecionado.permissoesExcluidas.length; i++) {
                    if(permSelect.codigo == this.planoSelecionado.permissoesExcluidas[i].codigo) {
                        this.planoSelecionado.permissoesExcluidas.splice(i, 1);
                    }
                }
            });
            let requisicao = {
                empresa: {id: this.empresa.id, nomeFantasia: this.empresa.nomeFantasia },
                plano: {...this.planoSelecionado},              
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.empresaService.trocarPlano(requisicao)
                .then(resp => {                                                                      
                    this.enviandoForm = false;
                    this.novoPlano = false;
                    this.permissaoExtraSelecionada = null;
                    this.validarEdicao();
                    exibirMensagem(this, resp);               
                })
                .catch(erro => {
                    this.enviandoForm = false;
                    exibirMensagem(this, erro);
                }); 
        },
        editarStatus() {           
           if(this.empresa.status != ''){  
               let requisicao = {
                    empresa: {
                        id: this.empresaEditarStatus.id, 
                        status: this.empresaEditarStatus.status, 
                        nomeFantasia: this.empresaEditarStatus.nomeFantasia,
                        motivoInativo: this.empresaEditarStatus.motivoInativo
                    },
                    idEmpresa: this.id,
					usuarioRequisicao: {...this.getDadosRequisicao()}
                };
                this.empresaService.editarStatus(requisicao)
                    .then(resp => {                                            
                        this.enviandoForm = false;  
                        this.empresa.status = this.empresaEditarStatus.status;
                        this.empresa.motivoInativo = this.empresaEditarStatus.motivoInativo;
                        this.fecharModal();                      
                        exibirMensagem(this, resp);                                               
                    })
                    .catch(erro => {
                        this.enviandoForm = false;
                        exibirMensagem(this, erro);
                    });       
             }
        },   
        panelNovoPlano() {            
            this.novoPlano = true;
            if(typeof this.$refs.formPlano === 'undefined') {
                setTimeout(() => {
                   this.panelNovoPlano(); 
                }, 100);
            } else {
                this.$refs.formPlano.carregar(this.planos); 
            }
        },     
        cancelar() {
            this.$router.push('/cadastro/clientes/ikponto');
        },
        editarStatusModal(){
            this.empresaEditarStatus = {...this.empresa};
            this.exibirDialogAlterarStatus = true;
        },
        formatarDocumento(event) {
            if(event && (event.keyCode == 8 || event.keyCode == 46)) {
                return;
            }
            let numeros = this.cnpj.numero.replace(/\D/g, '').split('');        
            let valor = '';    
            if(this.cnpj.tipoNumeroDocumento == 'cnpj') {          
                numeros.forEach((num)=> {
                    valor += ''+
                    num;
                    if(valor.length == 2 || valor.length == 6) {
                        valor += '.';
                    } else if(valor.length == 10) {
                        valor += '/';
                    } else if(valor.length == 15) {
                        valor += '-';
                    }
                });
            } else {// cpf             
                numeros.forEach((num)=> {
                    valor += ''+num;
                    if(valor.length == 3 || valor.length == 7) {
                        valor += '.';
                    } else if(valor.length == 11) {
                        valor += '-';
                    }
                });
            }
            this.cnpj.numero = valor;
        }, 
        fecharModal() {
            this.exibirDialogAlterarStatus = false;
		},
    },
    created() {
        this.planoService = new PlanoService();
        this.empresaService = new EmpresaService();
        this.menuService = new MenuService();
    },
    mounted() {        
        this.validarEdicao();        
    },
    components: {
        'FormPlano': FormPlano,
    }
}
</script>

<style>

</style>